import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkMathPlugin from 'remark-math';
import { BlockMath, InlineMath } from 'react-katex';
import 'katex/dist/katex.min.css';

const _mapProps = (props) => ({
  ...props,
  escapeHtml: false,
  plugins: [
    RemarkMathPlugin
  ],
  renderers: {
    ...props.renderers,
    math: ({ value }) => <BlockMath>{value}</BlockMath>,
    inlineMath: ({ value }) => <InlineMath>{value}</InlineMath>
  }
});

const Markdown = (props) => {

  let Input = props.children.replace(/(<p[^>]+?>|<p>)/, "<div>")
  Input=Input.replace(/(<\/p>)/, "</div></br>")
  Input=Input.replace(/<\/?span[^>]*>/g,"")

  return <ReactMarkdown {..._mapProps(props)} children={`<div>${Input}</div>`} />
};

export default Markdown;